import React from "react";
import cntl from "cntl";
import editIcon from "../../../../assets/images/editpencilgreen.svg";

const editButtonCN = cntl`
  w-4
  h-4
`;

const AttributeTableEditCell = ({ onClick }) => {
  return (
    <div className="flex flex-row items-center">
      <div>
        <button
          className={editButtonCN}
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
        >
          <img className="w-8 cursor-pointer" src={editIcon} alt="edit data" />
        </button>
      </div>
    </div>
  );
};

export default AttributeTableEditCell;
